import { SetStateAction, Dispatch } from 'react'
import { Divider } from 'antd'

import { getHasCustomerReviewedDfm } from '../logic'
import { ImDfmStateType } from '../constants'

import DeleteSlideIcon from './DeleteSlideIcon'
import DuplicateSlideIcon from './DuplicateSlideIcon'
import ResetSlideIcon from './ResetSlideIcon'

type SlideActionsPropsType = {
    dfmFeedbackId?: string | null
    idx: string
    is3dDfmSlide?: boolean
    isUnsaved?: boolean
    setActiveSlideIndex?: Dispatch<SetStateAction<number>>
    status?: ImDfmStateType | null
}

const SlideActions = (props: SlideActionsPropsType) => {
    const {
        dfmFeedbackId,
        idx,
        is3dDfmSlide,
        isUnsaved,
        setActiveSlideIndex,
        status,
    } = props

    const hasCustomerReviewedDfm = getHasCustomerReviewedDfm(status)

    return (
        <>
            {hasCustomerReviewedDfm && (
                <>
                    <ResetSlideIcon dfmFeedbackId={dfmFeedbackId} />
                    <Divider type="vertical" style={{ height: '25px' }} />
                </>
            )}
            {is3dDfmSlide && (
                <DuplicateSlideIcon dfmFeedbackId={dfmFeedbackId} idx={idx} />
            )}
            <DeleteSlideIcon
                isUnsaved={isUnsaved}
                dfmFeedbackId={dfmFeedbackId}
                idx={idx}
                setActiveSlideIndex={setActiveSlideIndex}
            />
        </>
    )
}

export default SlideActions
